/**
 * FursDevices API - Auto-generated typed wrapper.
 * DO NOT EDIT - Regenerate with: bun run generate
 * @generated
 */

import {
  getFursElectronicDevice,
  listFursElectronicDevices,
  registerFursElectronicDevice,
} from "../generated/furs-devices/furs-devices";

import { wrapMethod } from "./utils";

export const fursDevices = {
  /** @see listFursElectronicDevices */
  listFursElectronicDevices: wrapMethod(listFursElectronicDevices),

  /** @see registerFursElectronicDevice */
  registerFursElectronicDevice: wrapMethod(registerFursElectronicDevice),

  /** @see getFursElectronicDevice */
  getFursElectronicDevice: wrapMethod(getFursElectronicDevice),
} as const;

export type FursDevicesApi = typeof fursDevices;
